import { InjectionToken } from '@angular/core';

export interface HttpLoadingConfig {
  /** URLs to exclude from the loading indicator. */
  skipUrls?: (string | RegExp)[];
  /** Delay before showing the bar (avoids flicker on fast requests). */
  debounceMs?: number;
}

export const HTTP_LOADING_CONFIG = new InjectionToken<HttpLoadingConfig>(
  'HTTP_LOADING_CONFIG',
  {
    factory: () => ({
      skipUrls: ['/assets/'],
      debounceMs: 120,
    }),
  },
);

export function shouldSkipHttpLoading(
  url: string,
  skipUrls: (string | RegExp)[] | undefined,
): boolean {
  if (!skipUrls?.length) {
    return false;
  }

  return skipUrls.some((pattern) =>
    typeof pattern === 'string' ? url.includes(pattern) : pattern.test(url),
  );
}
